import { Col, Divider, Form, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import { MazakaPassword } from "apps/Common/MazakaPassword";
import useMazakaForm from "hooks/useMazakaForm";
import { useState } from "react";
import ConfirmLoginCode from "../ConfirmCode/ConfirmCode";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useNavigate } from "react-router-dom";
import Logo from "assets/Images/Header/FullLogo.svg";
import {
  getSMSVerifyCode,
  getTokenWithEmail,
  getUserInfoesByPhoneNumber,
} from "apps/Account/Services";
import SocialLoginOptions from "./Components/SocialLoginOptions";
import ForgotPassword from "./Components/ForgotPassword";
import GeneralPhoneNumber2 from "apps/Common/GeneralPhoneNumber2";
import { getUserInfoes } from "apps/CustomerPanel/Profile/Services";
import { useDispatch } from "react-redux";
import { handleSetUserInfoes } from "apps/CustomerPanel/Profile/ClientSideStates";
import { handleResetAllAdvertState } from "apps/CustomerPanel/Ad/ClientSideStates";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import PageTitle from "apps/Common/PageTitle";

const Login = (props: any) => {
  const [form] = Form.useForm();
  const [isResetPassValidation, setIsResetPassValidtion] =
    useState<boolean>(false);
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { Text } = Typography;
  const [isShowConfirmCode, setIsShowConfirmCode] = useState(false);
  const [loginType, setLoginType] = useState<"email" | "phone">("email");
  const [isShowForgotPassword, setIsShowForgotPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getUserInformations = async () => {
    try {
      const response: any = await getUserInfoes();
      if (response?.data) {
        dispatch(handleSetUserInfoes({ data: response.data }));
      }
    } catch (error: any) {
    } finally {
      // setIsLoading(false);
    }
  };

  const loginWithEmail = async (data: any) => {
    try {
      const response: any = await getTokenWithEmail(data);
      localStorage.setItem("access_token", response?.data);
      getUserInformations();
      mazakaForm.setSuccess(
        1000,
        () => {
          navigate("/admin/panel");
        },
        "Giriş Başarılı"
      );
      dispatch(handleResetAllAdvertState());
      props.onFinish();
      setIsResetPassValidtion(true);
      form.resetFields();
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message || "Email ve ya şifre hatalı");
      openNotificationWithIcon(
        "error",
        error?.message || "Email ve ya şifre hatalı"
      );

      console.log("Somethings wrong during login to dashboard", error);
    }
  };

  const loginWithPhone = async (formValues: any) => {
    try {
      let split_number = formValues["Phone"].split("+");
      let numberPrefix = split_number[0];
      let numberBody = split_number[1];
      const userInfoes = await getUserInfoesByPhoneNumber(
        numberPrefix,
        numberBody
      );
      if (userInfoes?.data?.id) {
        await getSMSVerifyCode(numberPrefix, numberBody);

        mazakaForm.setSuccess(1000, () => "Giriş Başarılı");
        setIsShowConfirmCode(true);
      } else {
        mazakaForm.setFailed(2000, "Kullanıcı Bulunamadı");
      }
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      openNotificationWithIcon("default", error?.message);

      console.log("Somethings wrong during login to dashboard", error);
    }
  };

  const handleOnFinish = () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    let data = {};
    if (loginType === "email") {
      data = {
        email: formValues["email"],
        password: formValues["password"],
        rememberMe: true,
      };
      loginWithEmail(data);
    } else {
      loginWithPhone(formValues);
    }
  };

  return (
    <>
      {isShowConfirmCode ? (
        <ConfirmLoginCode
          setIsShowConfirmCode={setIsShowConfirmCode}
          numberPrefix={form.getFieldValue("Phone")?.split("+")[0] || ""}
          numberBody={form.getFieldValue("Phone")?.split("+")[1] || ""}
          onFinish={props.onFinish}
        />
      ) : (
        <>
          {isShowForgotPassword ? (
            <>
              <ForgotPassword
                setIsShowForgotPassword={setIsShowForgotPassword}
                setLoginType={setLoginType}
                onFinish={props.onFinish}
              />
            </>
          ) : (
            <>
              <Col span={24} className={props.isPage?"justify-center md:!h-screen !flex md:items-center !mt-2 md:!mt-0 ":""} >
                <MazakaForm
                  submitButtonVisible={false}
                  form={form}
                  onFinish={handleOnFinish}
                >
                  <Row gutter={[10, 20]} className={`${props.isPage?"md:!max-w-[800px] shadow-lg !h-full    md:p-8 xl:!p-16":"!px-4 !w-full "}`}>
                    {props.isPage && (
                      <>
                        <Col span={24} className="!flex justify-center">
                          <LazyLoadImage
                            wrapperWidth="200px"
                            wrapperHeight="38px"
                            style={{ objectFit: "contain" }}
                            src={Logo}
                            alt="Sarı ilanlar logosu"
                          />
                        </Col>
                        <Col xs={24} className="!flex justify-center">
                        <PageTitle
                        title="Giriş Yap"
                        
                        />
                         
                        </Col>
                      </>
                    )}
                    {loginType === "email" ? (
                      <>
                        <MazakaInput
                          xs={24}
                          name={"email"}
                          label={"E-Posta"}
                          className="!m-0"
                          inputClassName="!bg-[#f7f7f7] !p-2"
                          rules={[
                            {
                              type: "email",
                              message: "E-Posta Formatı Geçersiz",
                            },
                            { required: true, message: "" },
                          ]}
                          placeholder={"E-Posta"}
                        />

                        <MazakaPassword
                          xs={24}
                          name={"password"}
                          isResetPassValidation={isResetPassValidation}
                          setIsResetPassValidation={setIsResetPassValidtion}
                          label={"Şifre"}
                          className="!m-0"
                          inputClassName="!bg-[#f7f7f7] !p-2"
                          placeholder="Şifrenizi girin"
                        />
                      </>
                    ) : (
                      <>
                        <GeneralPhoneNumber2
                          label={"Telefon Numarası"}
                          name="Phone"
                          required={true}
                          xs={24}
                          form={form}
                          placeholder={"Telefon Numarası"}
                          containerClass=""
                          className="!m-0"
                          rules={[
                            {
                              required: true,
                              message: "",
                            },
                          ]}
                        />
                      </>
                    )}

                    <Col xs={24}>
                      <MazakaButton
                        className="!p-4 !bg-[#FFC502] !text-black"
                        htmlType="submit"
                        block
                        processType={formActions.submitProcessType}
                      >
                        Giriş Yap
                      </MazakaButton>
                    </Col>

                    {loginType === "email" && (
                      <>
                        <Col xs={24} className="!flex justify-center">
                          <Text
                            onClick={() => {
                              setIsShowForgotPassword(true);
                            }}
                            className="!text-indigo-500 hover:cursor-pointer !text-xs"
                          >
                            Şifremi Unuttum
                          </Text>
                        </Col>
                      </>
                    )}

                    <Col span={24}>
                      <Divider className="!m-0" />
                    </Col>
                    <Col span={24} className="!flex justify-center">
                      <Text className="!text-base !text-gray-400">
                        Veya Bağlanın
                      </Text>
                    </Col>
                    <Col span={24} className="">
                      <SocialLoginOptions
                        loginType={loginType}
                        setLoginType={setLoginType}
                        setIsResetPassValidtion={setIsResetPassValidtion}
                        onFinish={props.onFinish}
                        form={form}
                      />
                    </Col>
                  </Row>
                </MazakaForm>
              </Col>
            </>
          )}
        </>
      )}
    </>
  );
};

export default Login;
